import { Outlet, NavLink, useNavigate, Navigate } from "react-router-dom";
import { LayoutDashboard, FileText, Mail, Share2, Building2, Settings as SettingsIcon, LogOut, Loader2 } from "lucide-react";
import Logo from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/applications", label: "Applications", icon: FileText },
  { to: "/admin/invitations", label: "Invitations", icon: Mail },
  { to: "/admin/share-links", label: "Share Links", icon: Share2 },
  { to: "/admin/properties", label: "Collection", icon: Building2 },
  { to: "/admin/settings", label: "Settings", icon: SettingsIcon },
];

export default function AdminLayout() {
  const { user, ready, logout } = useAuth();
  const navigate = useNavigate();

  if (!ready) return <div className="min-h-screen bg-navy-900 flex items-center justify-center text-ivory/40"><Loader2 className="animate-spin" /></div>;
  if (!user) return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen bg-navy-900 flex" data-testid="admin-layout">
      <aside className="hidden md:flex flex-col w-64 border-r border-ivory/10 bg-navy-900 fixed inset-y-0 left-0 z-20">
        <div className="px-6 py-8 border-b border-ivory/10"><Logo variant="wordmark" className="h-7" /><p className="mt-2 text-[9px] tracking-[0.3em] uppercase text-gold/70">Selection</p></div>
        <nav className="flex-1 px-3 py-6 space-y-1">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={`admin-nav-${n.label.toLowerCase()}`}
              className={({ isActive }) => `flex items-center gap-3 px-4 py-3 text-xs tracking-[0.12em] uppercase transition-colors duration-300 ${isActive ? "bg-navy-800 text-gold border-l-2 border-gold" : "text-ivory/55 hover:text-ivory hover:bg-navy-800/60 border-l-2 border-transparent"}`}>
              <n.icon size={16} /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="px-3 py-6 border-t border-ivory/10">
          <p className="px-4 text-[10px] text-ivory/40 truncate mb-3">{user.email}</p>
          <button onClick={async () => { await logout(); navigate("/admin/login"); }} data-testid="admin-logout-btn" className="w-full flex items-center gap-3 px-4 py-3 text-xs tracking-[0.12em] uppercase text-ivory/55 hover:text-red-300 transition-colors"><LogOut size={16} /> Sign Out</button>
        </div>
      </aside>

      {/* mobile top bar */}
      <div className="md:hidden fixed top-0 inset-x-0 z-20 bg-navy-900 border-b border-ivory/10 flex items-center justify-between px-4 py-3">
        <Logo variant="wordmark" className="h-6" />
        <div className="flex gap-3">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} className={({ isActive }) => `p-2 ${isActive ? "text-gold" : "text-ivory/50"}`}><n.icon size={18} /></NavLink>
          ))}
        </div>
      </div>

      <main className="flex-1 md:ml-64 pt-20 md:pt-0 min-w-0">
        <div className="p-6 md:p-10 max-w-[1500px]"><Outlet /></div>
      </main>
    </div>
  );
}
